import { createStore, persist, action } from "easy-peasy";

let model = {
  currentUser: { displayName: "", email: "" },
  setCurrentUser: action((state, payload) => {
    state.currentUser = payload;
  }),
  requirements: {
    recycledResin: "Characterized Resin", // source of recycledResin new or characterized
    virginResin: "Characterized Resin", // source of recycledResin new or characterized
    thickness: "",
    ldr: "",
    recycledResinConc: "",
    virginResinConc: "",
    selectedVirginResin: "", // info of the selected characterized VirginResin
    selectedRecycledResin: "", // info of the selected characterized RecycledResin
    // collection of the info from the selected new resin
    resinRequirement: {
      newResinRecycled: {
        resinName: "",
        batchNumber: "",
        thickness: "",
        fileName: "",
        rtCurve: {},
        dilutionDetails: {
          recycledResinConc: "",
          virginResinConc: "",
        },
      },
      newResinvirgin: {
        resinName: "",
        batchNumber: "",
        thickness: "",
        fileName: "",
        rtCurve: {},
      },
    },
    resinClass: "PO",
    isDonwlodBtnDisable: false,
    requestType: "tar",
  },
  evaluationResult: {
    gamut: {
      virginResinGamut: [],
      recycleResinGamut: [],
    },
    target_color: [],
  },
  setEvaluationResult: action((state, response) => {
    state.evaluationResult = response;
  }),
  setRequirements: action((state, payload) => {
    state.requirements = payload;
  }),
  inputColor: {
    uploadedColorArray: [],
    fileName: "",
  },
  setInputColor: action((state, payload) => {
    state.inputColor = payload;
  }),
  downloadBtnDisabled: false,
  setDownloadBtnDisabled: action((state, payload) => {
    state.downloadBtnDisabled = payload;
  }),
  downloadReport: {
    pointsVisible: ["All"],
  },
  setDownloadReport: action((state, response) => {
    state.downloadReport = response;
  }),
  nextBtnDisabled: true,
  setNextBtnDisabled: action((state, payload) => {
    state.nextBtnDisabled = payload;
  }),
  newFormErrors: {
    thickness: {
      required: true,
      highlight: false,
    },
    ldr: {
      required: true,
      highlight: false,
    },
    recycledResinConc: {
      required: true,
      highlight: false,
    },
    requestNumber: {
      required: true,
      highlight: false,
    },
    virgin: {
      required: true,
      highlight: false,
    },
    recycled: {
      required: true,
      highlight: false,
    },
  },
  setNewFormErrors: action((state, payload) => {
    // Check if the payload is a function
    if (typeof payload === "function") {
      state.newFormErrors = payload(state.newFormErrors);
    } else {
      console.log("inside the else of setnewformerrors");
      // If it's a regular object, set the state directly
      state.newFormErrors = payload;
    }
  }),
  virginDialogErrors: {
    thickness: {
      required: true,
      highlight: false,
    },
    // upload: {
    //   required: true,
    //   highlight: false,
    // },
    resinName: {
      required: true,
      highlight: false,
    },
  },

  setVirginDialogErrors: action((state, payload) => {
    // Check if the payload is a function
    if (typeof payload === "function") {
      state.virginDialogErrors = payload(state.virgnDialogErrors);
    } else {
      // If it's a regular object, set the state directly
      state.virginDialogErrors = payload;
    }
  }),

  recycledDialogErrors: {
    thickness: {
      required: true,
      highlight: false,
    },
    // upload: {
    //   required: true,
    //   highlight: false,
    // },
    resinName: {
      required: true,
      highlight: false,
    },
    recycledResinConc: {
      required: true,
      highlight: false,
    },
  },

  setRecycledDialogErrors: action((state, payload) => {
    // Check if the payload is a function
    if (typeof payload === "function") {
      state.recycledDialogErrors = payload(state.recycledDialogErrors);
    } else {
      // If it's a regular object, set the state directly
      state.recycledDialogErrors = payload;
    }
  }),
};

export const easyPeasyStore = createStore(
  persist(model, {
    mergeStrategy: "overwrite",
    storage: "sessionStorage",
    allow: ["currentUser", "requirements", "inputColor", "downloadBtnDisabled"],
  })
);
